<template>
    <div
        class="p-4 border border-gray-200 dark:border-gray-700 rounded-lg"
        :class="getNotificationStyle(notification.type)"
    >
        <div class="flex items-start">
            <div class="shrink-0">
                <Icon :type="getIcon(notification.type)" :class="getIconColor(notification.type)" class="text-xl" />
            </div>

            <div class="ml-4 flex-auto">
                <p class="text-gray-800 dark:text-gray-300 font-medium">
                    {{ notification.title }}
                    <span v-if="notification.is_all_day" class="text-sm text-blue-500">
                        (All Day - {{ formatDate(notification.from_date) }})
                    </span>
                </p>

                <p class="text-sm text-gray-600 dark:text-gray-400">
                    {{ notification.description || 'No description available' }}
                </p>

                <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                    <span v-if="!notification.is_all_day">
                        From: {{ formatDate(notification.from_date) }} at {{ formatTime(notification.from_time) }}
                        <br />
                        To: {{ formatDate(notification.to_date) }} at {{ formatTime(notification.to_time) }}
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardMessageNotification',
    props: {
        notification: {
            type: Object,
            required: true,
        },
    },

    methods: {
        getIcon(type) {
            switch (type) {
                case 'event': return 'calendar';
                case 'note': return 'information-circle';
                case 'reminder': return 'bell';
                default: return 'notification';
            }
        },

        getIconColor(type) {
            switch (type) {
                case 'event': return 'text-blue-500';
                case 'note': return 'text-green-500';
                case 'reminder': return 'text-red-500';
                default: return 'text-gray-500';
            }
        },

        getNotificationStyle(type) {
            switch (type) {
                case 'event': return 'border-l-4 border-blue-500 bg-blue-50 dark:bg-blue-900';
                case 'note': return 'border-l-4 border-green-500 bg-green-50 dark:bg-green-900';
                default: return 'border-l-4 border-gray-500 bg-gray-50 dark:bg-gray-900';
            }
        },

        formatDate(date) {
            if (!date) return 'Unknown date';
            return new Date(date).toLocaleDateString();
        },

        formatTime(time) {
            if (!time) return 'Unknown time';
            return time.substring(0, 5); // Extract HH:MM from HH:MM:SS
        },
    },
};
</script>
